
export enum HandlingUnitMovementTypeCd {
	CLOSE = 'Close',
	DELIVER = 'Deliver',
	LOAD = 'Load',
	PICKUP = 'Pickup',
	SCAN = 'Scan',
	STAGE = 'Stage',
	TRANSFER = 'Transfer',
	UNLOAD = 'Unload'}
